import React from 'react';
import PropTypes from 'prop-types';
/* styles */
import './radio-button.scss';

class RadioButton extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isFocused: false,
    };
  }

  componentDidMount() {
    if (this.props.isChecked) {
      this.autoFocusTimeout = setTimeout(() => {
        this.input.focus();
      }, this.props.autoFocusDelay);
    }
  }

  componentWillUnmount() {
    if (this.autoFocusTimeout) {
      clearTimeout(this.autoFocusTimeout);
    }
  }

  onFocus = () => {
    this.setState({isFocused: true});
  };

  onBlur = () => {
    this.setState({isFocused: false});
  };

  getRadioLabelClass() {
    let radioClass = 'glu-radio-button';
    if (this.props.isChecked) {
      radioClass += ' glu-radio-button--checked';
    }
    if (this.props.className) {
      radioClass += ` ${this.props.className}`;
    }
    if (this.props.isDisabled) {
      radioClass += ' glu-radio-button--disabled';
    }
    if (!this.props.children) {
      radioClass += ' glu-radio-button--no-label';
    }
    if (this.state.isFocused) {
      radioClass += ' glu-radio-button--focused';
    }
    return radioClass;
  }

  render() {
    return (
      <label className={this.getRadioLabelClass()} htmlFor={this.props.id}>
        <input
          type="radio"
          id={this.props.id}
          name={this.props.name || this.props.id}
          ref={(input) => {
            this.input = input;
          }}
          value={this.props.value}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          onChange={this.props.onChange}
          checked={this.props.isChecked}
          disabled={this.props.isDisabled}
        />
        {this.props.children}
      </label>
    );
  }
}

RadioButton.propTypes = {
  autoFocusDelay: PropTypes.number,
  children: PropTypes.node,
  className: PropTypes.string,
  id: PropTypes.string,
  isChecked: PropTypes.bool,
  isDisabled: PropTypes.bool,
  name: PropTypes.string,
  onChange: PropTypes.func,
  stopClickPropagation: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
};

RadioButton.defaultProps = {
  autoFocusDelay: 500,
  children: null,
  className: '',
  id: null,
  isChecked: false,
  isDisabled: false,
  name: '',
  onChange: undefined,
  stopClickPropagation: false,
  value: '',
};

export default RadioButton;
